import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { PageIntro } from '../components/layout/PageIntro';
import { useSeo } from '../hooks/useSeo';
import { PAGE_SEO } from '../seo/site';

const ImpressumPage = () => {
  useSeo(PAGE_SEO.impressum);
  return (
    <>
      <Header />
      <main data-testid="impressum-page">
        <PageIntro eyebrow="Rechtliches" title="Impressum" />
        <div className="wrap max-w-4xl sec--tight">
          <div className="space-y-8">
            <section>
              <h2 className="font-display font-bold text-2xl mb-3">Angaben gemäß § 5 TMG</h2>
              <p className="text-[1rem] leading-relaxed text-ink/90">
                GND Gastro Next Digital UG (haftungsbeschränkt)<br />
                Spritzenplatz 16<br />
                22765 Hamburg<br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl mb-3">Kontakt</h2>
              <p className="text-[1rem] leading-relaxed text-ink/90">
                Telefon: 0178 726 1209<br />
                E-Mail: maximilian@gastro-beratung.de
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl mb-3">Vertreten durch</h2>
              <p className="text-[1rem] leading-relaxed text-ink/90">
                Geschäftsführer: Maximilian Schneider-Ludorff
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl mb-3">Registereintrag</h2>
              <p className="text-[1rem] leading-relaxed text-ink/90">
                Eintragung im Handelsregister<br />
                Registergericht: Amtsgericht Hamburg<br />
                Registernummer: HRB 194103
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl mb-3">Umsatzsteuer-ID</h2>
              <p className="text-[1rem] leading-relaxed text-ink/90">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                DE458317574
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <p className="text-[1rem] leading-relaxed text-ink/90">
                Maximilian Schneider-Ludorff<br />
                Spritzenplatz 16<br />
                22765 Hamburg
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl mb-3">Streitschlichtung</h2>
              <p className="text-[1rem] leading-relaxed text-ink/90">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-purple underline underline-offset-4 hover:text-deep ml-1 break-all">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="text-[1rem] leading-relaxed text-ink/90 mt-2">
                Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, 
                an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl mb-3">Haftung für Inhalte</h2>
              <p className="text-[1rem] leading-relaxed text-ink/90">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
                allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
                verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen 
                zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="text-[1rem] leading-relaxed text-ink/90 mt-2">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
                Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt 
                der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden 
                Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl mb-3">Haftung für Links</h2>
              <p className="text-[1rem] leading-relaxed text-ink/90">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
                verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl mb-3">Urheberrecht</h2>
              <p className="text-[1rem] leading-relaxed text-ink/90">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
                Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
                Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ImpressumPage;
